{
    "title": "Company Description and Activity",
    "input":{
        "descriptionOfBusinessNature": "Nature of Business",
        "naics": "Choose your commercial industry",
        "corporateEntityType": "Corporate Entity Type",
        "corporateEntityTypeDescription": "Corporate Entity Type Description"
    }
}